import React from "react";
import useGetOptionTitle from "../hooks/useGetOptionTitle";
import TranslatedKey from "./TranslatedKey";
import { XCircleIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import { splitCode } from "@feature/kcolor/utils/utils";

const ServiceConfiguratorQuestionSelectOption = ({
  option,
  active,
  realtime,
  output,
}) => {
  const getOptionTitle = useGetOptionTitle();
  const title = getOptionTitle(option);
  const isBool = typeof option?.title === "boolean";
  const isColor = option?.isColor;

  return (
    <div className={`relative flex flex-col ${realtime ? "w-32" : "w-40"} `}>
      {option.image_filename ? (
        <div
          style={{
            paddingBottom: "100%",
            ...(option.image_filename
              ? { backgroundImage: `url(${"/" + option.image_filename})` }
              : {}),
          }}
          className={`absolute top-0 left-0 w-full h-full bg-cover bg-center bg-gray-100 relative border-2 ${
            active ? "border-am-700" : "border-transparent"
          }`}
        />
      ) : null}

      <div className="mt-1 flex-col">
        {isBool ? (
          title ? (
            <div className={`ml-auto text-green-400 ${"w-10 h-10"}`}>
              <CheckCircleIcon />
            </div>
          ) : (
            <div className={`ml-auto text-red-400 ${"w-10 h-10"}`}>
              <XCircleIcon />
            </div>
          )
        ) : title && !isColor ? (
          <div className="mb-1">
            <h2
              className={output && !realtime ? "text-xl" : "text-xs"}
            >
              <TranslatedKey id={title} />
            </h2>
          </div>
        ) : null}
        {isColor ? (
          <div className={"flex flex-row justify-end items-end gap-x-2"}>
            <div
              className="w-5"
              style={{
                border: '1px solid #000000',
                backgroundColor: option?.title?.code ? `rgb(${option.title.rgb.join(', ')})` : '#fff2',
                aspectRatio: '1'
              }}
            />
            <span className="font-bold">
                {splitCode(option?.title?.code || "")}
              </span>
          </div>) : null}
        {option.description && !realtime ? (
          <div className="mb-1">
            <p className="text-xs">
              <TranslatedKey id={option.description}/>
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ServiceConfiguratorQuestionSelectOption;